// import { useState } from "react";
// import {
//   getStorage,
//   ref,
//   uploadBytesResumable,
//   getDownloadURL,
// } from "firebase/storage";
// import { v4 as uuidv4 } from "uuid";
// import { auth, db } from "../../firebase";
// import {
//   doc,
//   setDoc,
//   addDoc,
//   collection,
//   serverTimestamp,
// } from "firebase/firestore";

// import css from "../admin/adm.module.css";
// export default function AddBlog() {
//   const objList = [
//     {
//       name: "Заголовок",
//       transliter: "zag",
//     },
//     {
//       name: "Перший опис",
//       transliter: "chortDesc",
//     },
//     {
//       name: "Другий опис",
//       transliter: "centrDesc",
//     },
//     {
//       name: "Третій",
//       transliter: "longDesc",
//     },
//     {
//       name: "ID відео",
//       transliter: "videoId",
//     },
//   ];

//   const [formData, setFormData] = useState({});
//   const [file, setFile] = useState(null);

//   const handleFormSubmit = async (event) => {
//     event.preventDefault();

//     const form = event.target;
//     const formDataValue = new FormData(form);
//     const formDataObj = Object.fromEntries(formDataValue.entries());
//     setFormData(formDataObj);

//     console.log("formData", formDataObj);

//     if (file) {
//       try {
//         const newObj = { ...formDataObj };
//         const storage = getStorage();
//         const storageRef = ref(storage, `blog/${uuidv4()}/${file.name}`);
//         const uploadTask = uploadBytesResumable(storageRef, file);

//         uploadTask.on(
//           "state_changed",
//           (snapshot) => {
//             const progress =
//               (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
//             console.log("Upload progress:", progress);
//           },
//           (error) => {
//             console.error("Error uploading file:", error);
//           }
//         );

//         await uploadTask;

//         const downloadURL = await getDownloadURL(storageRef);
//         newObj.photo = downloadURL;
//         newObj.uid = uuidv4();
//         newObj.timestamp = serverTimestamp();
//         await addDoc(collection(db, "blog"), newObj);

//         console.log("Стаття успішно додана до Firestore:", newObj);
//       } catch (error) {
//         console.error("Помилка під час додавання статті:", error);
//       }
//     } else {
//       console.log("Фото не вибрано");
//     }
//   };

//   const handleFileChange = (event) => {
//     const selectedFile = event.target.files[0];
//     setFile(selectedFile);
//   };

//   return (
//     <div className={css.blogWrap}>
//       <form onSubmit={handleFormSubmit}>
//         {objList.map((el, index) => (
//           <div key={index} className={css.wrapSmallList}>
//             <p className={css.paramBooks}>{el.name}</p>
//             <input type="text" name={el.transliter} id="nameProp" />
//           </div>
//         ))}

//         <div className={css.wrapSmallList}>
//           <p className={css.paramBooks}>Фото</p>
//           <input type="file" name="photo" onChange={handleFileChange} />
//         </div>

//         <button className={css.addBookButtonBlog} type="submit">
//           Додати статтю
//         </button>
//       </form>
//     </div>
//   );
// }
import { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import css from "../admin/adm.module.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function AddBlog() {
  const objList = [
    { name: "Заголовок", transliter: "zag" },
    { name: "Перший опис", transliter: "chortDesc" },
    { name: "ID відео", transliter: "videoId" },
    { name: "SEO title", transliter: "seoTitle" },
    { name: "SEO description", transliter: "seoDescription" },
  ];

  const [formData, setFormData] = useState({});
  const [file, setFile] = useState(null);
  const [longDesc, setLongDesc] = useState("");
  const [check, setCheck] = useState(false); // 🔧 чекбокс
  const [linkto, setLinkto] = useState(""); // 🔧 новий інпут

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    const form = event.target;
    const formDataValue = new FormData(form);
    const formDataObj = Object.fromEntries(formDataValue.entries());
    formDataObj.longDesc = longDesc;
    formDataObj.check = check;

    if (check && linkto.trim()) {
      formDataObj.linkto = linkto.trim(); // ✅ додаємо linkto якщо є
    }

    if (file) {
      try {
        const newObj = { ...formDataObj };
        const storage = getStorage();
        const storageRef = ref(storage, `blog/${uuidv4()}/${file.name}`);
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on("state_changed", (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload progress:", progress);
        });

        await uploadTask;
        const downloadURL = await getDownloadURL(storageRef);

        newObj.photo = downloadURL;
        newObj.uid = uuidv4();
        newObj.timestamp = serverTimestamp();

        await addDoc(collection(db, "blog"), newObj);
        console.log("Стаття успішно додана:", newObj);
      } catch (error) {
        console.error("Помилка при додаванні:", error);
      }
    } else {
      console.log("Фото не вибрано");
    }
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  return (
    <div className={css.blogWrapnewBlog}>
      <form onSubmit={handleFormSubmit}>
        {objList.map((el, index) => (
          <div key={index} className={css.wrapSmallListnewBlog}>
            <p className={css.paramBooksnewBlog}>{el.name}</p>
            <input
              type="text"
              name={el.transliter}
              className={css.inputnewBlog}
            />
          </div>
        ))}

        <div className={css.wrapSmallListnewBlog}>
          <p className={css.paramBooksnewBlog}>Третій (довгий опис)</p>
          <ReactQuill
            value={longDesc}
            onChange={setLongDesc}
            className={css.quillEditornewBlog}
            modules={{
              toolbar: [
                [{ header: [1, 2, 3, false] }],
                ["bold", "italic", "underline", "strike", "link"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ align: [] }],
                ["clean"],
              ],
            }}
            formats={[
              "header",
              "bold",
              "italic",
              "underline",
              "strike",
              "link",
              "list",
              "bullet",
              "align",
            ]}
          />
        </div>

        <div className={css.wrapSmallListnewBlog}>
          <p className={css.paramBooksnewBlog}>Фото</p>
          <input
            type="file"
            name="photo"
            onChange={handleFileChange}
            className={css.inputnewBlog}
          />
        </div>

        <div className={css.wrapSmallListnewBlog}>
          <label className={css.paramBooksnewBlog}>
            <input
              type="checkbox"
              checked={check}
              onChange={(e) => setCheck(e.target.checked)}
            />
            &nbsp;Посилання на сторонній сайт
          </label>
        </div>

        {check && (
          <div className={css.wrapSmallListnewBlog}>
            <p className={css.paramBooksnewBlog}>Посилання</p>
            <input
              type="text"
              value={linkto}
              onChange={(e) => setLinkto(e.target.value)}
              className={css.inputnewBlog}
              placeholder="https://example.com"
            />
          </div>
        )}

        <button className={css.addBookButtonBlognewBlog} type="submit">
          Додати статтю
        </button>
      </form>
    </div>
  );
}
